<template>
    <div style="width: 100%;" ref="chatScrollView">
        <!-- 开场白 -->
        <div class="egclass" v-if="prologue">
            <!-- 变量参数 -->
            <div style="width: 100%;margin: 10px auto;">
                <!-- <agent-key :user_input_form="agentVar" :inputsInfo="inputsInfo" :agentVarObj="agentVarObj"
                    @inputsInfoChange="WxAiChatSession.conversationInputs = $event" /> -->
                <div class="selectors-section">
                    <div class="selector-item">
                        <el-form :model="inputsInfo" label-width="100px" ref="inputsForm" label-position="left"
                            style="width: 90%;margin: 5px auto;">
                            <el-form-item label="客户类型" prop="">
                                <el-select v-model="inputsInfo.kehuleixing" placeholder="请选择客户类型" style="width:100%;"
                                    @change="kehuleixingChange">
                                    <el-option v-for="(option, idx) in kehuleixingOptions" :key="idx"
                                        :label="option.text" :value="option.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="行业场景" prop="">
                                <el-select v-model="inputsInfo.hangyechangjing" placeholder="请选择行业场景"
                                    style="width:100%;">
                                    <el-option v-for="(option, idx) in hangyechangjingOptions" :key="idx"
                                        :label="option.text" :value="option.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="客情阶段" prop="">
                                <el-select v-model="inputsInfo.keqingjieduan" placeholder="请选择客情阶段" style="width:100%;">
                                    <el-option v-for="(option, idx) in keqingjieduanOptions" :key="idx"
                                        :label="option.text" :value="option.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="难易程度" prop="">
                                <el-select v-model="inputsInfo.nanyichengdu" placeholder="请选择难易程度" style="width:100%;">
                                    <el-option v-for="(option, idx) in nanyichengduOptions" :key="idx"
                                        :label="option.text" :value="option.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <div style="width: 100%;" class="textWrapClass">{{ prologue.textValue }}</div>
            <div style="width: 100%;margin: 20px 0 0;" v-if="prologue && prologue.eg && prologue.eg.length > 0">
                <div v-for="(itemName, id) in prologue.eg" :key="id"
                    style="max-width: 100%; margin: 0 0 10px 10px;color: #356CFD;" @click="gotoEg(itemName)">
                    <span style="border-bottom: 1px solid #356CFD;padding-bottom: 5px;">{{ itemName }}</span>
                </div>
            </div>
            <div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 20px;"
                v-if="!isStartBtn">
                <el-button style="width: 60%;" round @click="startDialog">开始演练</el-button>
            </div>
        </div>
        <!-- 聊天内容 -->
        <template v-for="(item, index) in diaArr">
            <div v-if="item.type == 1 || item.type == 3 || item.type == 4">
                <div :class="[item.type == 4 ? 'egclass' : 'message']">

                    <div v-if="item.type == 3">
                        {{ item.conter }}
                        <span>{{ loadingText }}</span>
                    </div>



                    <div v-if="item.type == 1 && item.think">
                        <div style="color: #356CFD;height: 40px;line-height: 40px;width: 100%;background-color:#EBEEF5;
                                    border-radius: 10px;padding-left: 20px;" @click="collapseTap(index)">{{ item.conter
                                        ? '已结束深度思考:' : '思考中......' }}
                            <i class="el-icon-arrow-down" style="size: 18px;margin-left: 10px;"
                                v-if="item.IsCollapse"></i>
                            <i class="el-icon-arrow-up" style="size: 18px;margin-left: 10px;" v-else></i>
                        </div>
                        <div v-if="item.IsCollapse"
                            style="width:98%;border-left: 3px solid #817e7e;padding: 10px 0 10px 10px; margin-left:15px;margin-top: 15px;
                                        margin-bottom: 15px; color:#817e7e ;line-height: 30px;word-wrap: break-word;white-space: pre-wrap;">
                            {{ item.think }}
                        </div>
                    </div>

                    <div v-if="item.type == 1 || item.type == 4" v-html="item.conter"
                        style="width: 100%;line-height: 30px;">
                    </div>

                    <div style="color: #356CFD;height: 40px;line-height: 40px;width: 100%;background-color:#EBEEF5;
                                    border-radius: 10px;padding-left: 20px;margin: 10px auto;"
                        v-if="item.fileList && item.fileList.length > 0" @click="collapseFileTap(index)">
                        引用{{ item.fileList.length }}个文件作为参考
                        <i class="el-icon-arrow-down" style="size: 18px;margin-left: 10px;" v-if="item.IsFlieShow"></i>
                        <i class="el-icon-arrow-up" style="size: 18px;margin-left: 10px;" v-else></i>
                    </div>

                    <div v-if="item.IsFlieShow"
                        style="width:96%;margin: 10px auto;border-left: 3px solid #817e7e;padding-left:20px">
                        <el-collapse v-model="activeNames">
                            <template v-for="(fileListItem, fileListIndex) in item.fileList">
                                <el-collapse-item
                                    :title="'[' + fileListItem.position + ']' + ':' + fileListItem.document_name"
                                    :name="fileListItem.position">
                                    <div style="max-height: 200px;padding: 10px;overflow: auto;">
                                        {{ fileListItem.content }}
                                    </div>
                                    <div style="height: 45px;line-height: 45px;font-size: 15px;display: flex;align-items: center;
                                                flex-direction: row-reverse;border-top:1px solid #DCDFE6 ;">
                                        <div style="margin-right: 20px;color:#909399;font-size:14px"> 来自:{{
                                            fileListItem.dataset_name }}</div>
                                        <!-- <div style="margin-right: 20px;color:red;font-size:14px"
                                            @click="DownFile(fileListItem)"> 下载原文件</div> -->
                                    </div>
                                </el-collapse-item>
                            </template>
                        </el-collapse>
                    </div>




                </div>

                <div style="display: flex;flex-direction: column;"
                    v-if="item.type == 1 && item.FollowUpQuery && item.FollowUpQuery.length > 1 && index == diaArr.length - 1">
                    <template v-for="(FollowUpQueryItem, FollowUpQueryIndex) in item.FollowUpQuery">
                        <div v-if="FollowUpQueryItem.text" @click="queryClick(FollowUpQueryItem.text)">
                            <span style="padding: 15px 20px;margin-left: 10px;line-height: 50px;background-color: #EBEEF5;
                                    border-radius: 5px;height: 35px;font-size: 18px;margin-top: 15px;max-width: 80%;">
                                {{ FollowUpQueryItem.text }}
                            </span>
                        </div>
                    </template>
                </div>

            </div>

            <div class="flex-right"
                style="display: flex;align-items: flex-end;flex-direction: column;margin-right: 10px;"
                v-if="item.type == 2">
                <div class="message2">
                    {{ item.conter }}
                </div>
            </div>

        </template>
        <div style="width: 100%;" :style="{ 'height': isOver ? '300px' : '0' }">
            <div ref="eCharts1" style="width: 100%;height: 100%; margin: 20px auto;"></div>
        </div>
        <div style="height: 300px;"></div>

    </div>
</template>
<script>
import { getAiAppDetails, addAiUserChatOneDify, addAiUserChatMsg, deleteAiUserChat, getAiUserChatDetails, exportAiUserChatMsgWord } from "../../api/api";
import agentKey from "../agentKey/agentKey.vue";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import MarkdownIt from 'markdown-it';
const md = new MarkdownIt({
    html: true,
    breaks: true,
    linkify: true
});
var FileSaver = require('file-saver');
import * as echarts from 'echarts';
export default {
    name: 'agentAiChat',
    components: {
        agentKey,
    },
    props: {
        agentMsg: {
            default: ""
        },
        query: {
            default: ""
        },
    },

    data() {
        return {
            color: [
                " #4992ff",
                " #dd79ff",
                " #fddd60",
                "  #ff6e76",
                " #58d9f9",
                " #05c091",
                "  #ff8a45",
                " #8d48e3"
            ],
            echartsStr: "",
            echartsStrValue: [],
            firstArray: [],
            secondArray: [],
            isOver: false,
            isStartBtn: false,
            kehuleixingOptions: [],
            hangyechangjingOptions: [],
            keqingjieduanOptions: [],
            nanyichengduOptions: [],
            activeNames: [],
            isAfterAnswer: false,
            typingTimer: null, // 打字机定时器
            typingSpeed: 25, // 打字速度（ms/字，可调整）
            totalAnswerText: '', // 已接收的完整文本（字符池）
            displayAnswerText: '', // 正在展示的文本（打字机实时更新）
            isTyping: false, // 是否正在执行打字机动画
            isStreamEnd: false,
            loadingNums: 0,
            loadingText: '.',
            AnswerIndex: 0,
            answerIndex: 0,
            copyImg: 'https://txcloud.aojuai.com/icon/ajtools/agent/copy.png',
            down_icon: 'https://txcloud.aojuai.com/icon/ajtools/agent/down_word.png',
            jianpan: 'https://txcloud.aojuai.com/icon/aojv/aiwx_icon/jianpan.png',
            shuaxin: 'https://txcloud.aojuai.com/icon/aojv/aiwx_icon/shuaxin.png',
            answer_arrCopy: [],
            isPopup: false,
            isOpen: false,
            yuyin2: 'https://txcloud.aojuai.com/icon/aojv/aiwx_icon/yuyin2.png',
            cjdh: 'https://txcloud.aojuai.com/icon/aojv/aiwx_icon/cjdh.png',
            isStop: false,
            think_arr: [], //思考的数组
            answer_arr: [], //答案
            stopArr: [],
            ydyKey: '',
            chatData: '', //
            conversationId: '', //大模型对话id
            isMkfShow: false,
            isFilePop: false,
            fileList: [],
            mergeArr: [],
            isMerge: false,
            AnswerMsg: '',
            ThinkIndex: 0,
            ThinkMsg: '',
            DmxIndex: 0,
            ArgChat: '', //
            agrentData: null, //当前智能体的信息
            WxAiChatSession: null, //当前会话信息
            diaArr: [], //对话聊天信息
            prologue: '', //开场白
            agentVar: [], //智能体变量参数
            agentVarObj: {},
            isAfterAnswer: null, //当前智能体是否允许开启下一步建议
            inputsInfo: {}, //当前智能体变量参数值
        };
    },
    computed: {

    },
    watch: {
        agentMsg: {
            handler(newVal, oldVal) {
                if (newVal && newVal.aaId) {
                    this.inputsInfo = {};
                    this.isStartBtn = false;
                    this.userInfo = localStorage.getItem('aojuAi_userName')
                    if (newVal.aucId) {
                        getAiUserChatDetails({
                            aucId: newVal.aucId
                        }).then(ress => {
                            if (ress.data.aiUserChatMsgList && ress.data.aiUserChatMsgList.length > 0) {
                                const data = JSON.parse(JSON.stringify(ress.data));
                                if (ress.data.aucAnswerEvaluate && ress.data.aucAnswerEvaluate != '{}') {
                                    var aucAnswerEvaluate = JSON.parse(ress.data.aucAnswerEvaluate);
                                    this.firstArray = aucAnswerEvaluate[0].firstArray;
                                    this.secondArray = aucAnswerEvaluate[0].secondArray;
                                    this.echartsStrValue = {
                                        xdata: [],
                                        data: []
                                    };
                                    this.isOver = true;
                                    this.$nextTick(() => {
                                        this.initEcharts()
                                    })
                                }
                                this.WxAiChatSession = data;
                                this.agrentData = data.aiApp;
                                this.WxAiChatSession.conversationInputs = ress.data.conversationInputs && ress.data.conversationInputs.length > 0 ? JSON.parse(data.conversationInputs) : {};
                                console.log(ress.data.conversationInputs);
                                if (ress.data.conversationInputs && ress.data.conversationInputs.length > 0) {
                                    this.$set(this, 'inputsInfo', data.conversationInputs);
                                    console.log(this.inputsInfo)
                                }
                                this.diaArr = []
                                this.getAiAppInputsKey2()
                                ress.data.aiUserChatMsgList.forEach(element => {
                                    if (element.yuamrQuestion) {
                                        const query = {
                                            conter: element.yuamrQuestion,
                                            type: 2
                                        }
                                        this.diaArr.push(query)
                                        if (element.yuamrAnswer) {
                                            const query = {
                                                conter: element.yuamrAnswer,
                                                think: element.yuamrThink ? element.yuamrThink : '',
                                                fileList: element.yuamrFiles ? JSON.parse(element.yuamrFiles) : [],
                                                yuamrId: element.yuamrId ? element.yuamrId : '',
                                                type: 1,
                                                IsCollapse: true,
                                                stop: true,
                                            }
                                            this.diaArr.push(query);
                                            this.isPopup = false;
                                            this.theConversationId = element.conversationId

                                        }
                                    }
                                });

                            }
                        })
                        return
                    }
                    getAiAppDetails({
                        aaId: newVal.aaId
                    }).then(res => {
                        this.agrentData = res.data;
                        this.diaArr = []
                        this.isAfterAnswer = false
                        this.isStreamEnd = false
                        this.IsFlieShow = false
                        this.WxAiChatSession = res.data;
                        this.WxAiChatSession.conversationId = '';
                        this.WxAiChatSession.conversationInputs = '';
                        this.userInfo = localStorage.getItem('aojuAi_userName')
                        this.getAiAppInputsKey()
                    })
                }
            },
            deep: true,
            immediate: true,
        },
        query: {
            handler(newVal, oldVal) {
                if (this.isOver) {
                    return this.$message({
                        message: '本次演练已结束,请重新开始训练',
                        type: 'success'
                    });
                }
                if (this.inputsInfo.kehuleixing && this.inputsInfo.hangyechangjing &&
                    this.inputsInfo.keqingjieduan && this.inputsInfo.nanyichengdu) {
                    const myMsg = {
                        type: 2,
                        conter: newVal
                    }
                    const load = {
                        type: 3,
                        conter: '我正在努力思考，请稍等',
                        stop: false,
                    }
                    this.WxAiChatSession.conversationInputs = this.WxAiChatSession.conversationInputs ? this.WxAiChatSession.conversationInputs : this.inputsInfo
                    this.diaArr.push(myMsg)
                    this.diaArr.push(load)
                    this.isStartBtn = true;
                    this.getTime();
                    this.Dify_requestTask_api(newVal)
                } else {
                    this.$message({
                        message: '请选择演练参数',
                        type: 'danger'
                    });
                }
            },
            deep: true
        }


    },
    created() {

    },
    mounted() {

    },
    methods: {
        kehuleixingChange(e) {
            const arr = JSON.parse(JSON.stringify(this.hangyechangjingOptionsCopy))
            const newArr = arr.filter(item => {
                return item.value.includes(e + '-')
            })
            this.hangyechangjingOptions = newArr;
            this.inputsInfo.hangyechangjing = newArr.length > 0 ? newArr[0].value : ''
        },
        initEcharts() {
            var that = this
            var maxNum = "";
            that.isOver = true;
            that.echartsStrValue.xdata = that.secondArray
            that.firstArray.forEach(
                (items, index) => {
                    that.echartsStrValue.data.push({
                        name: items,
                        max: ""
                    });
                }
            );
            maxNum = Math.max(...that.echartsStrValue.xdata);
            that.echartsStrValue.data.forEach(item => {
                item.max = maxNum;
            });

            console.log(echarts);
            that.$nextTick(() => {
                that.echartsStr.resize()
            })
            that.echartsStr = echarts.init(that.$refs.eCharts1);
            that.echartsStr.setOption({
                darkMode: " auto",
                colorBy: "series",
                color: that.color,
                // backgroundColor: '#100C2A',


                tooltip: {
                    trigger: "item"
                }, //提示框组件 ---数据项图形触发
                legend: {
                    // orient: 'vertical', //图标列表的布局朝向
                    right: "3%",
                    top: "3%",
                    data: ["训练分析"]
                },
                radar: {
                    // shape: 'circle',
                    indicator: that.echartsStrValue.data
                },
                series: [
                    {
                        type: "radar",
                        radius: "100%",
                        data: [
                            {
                                value: that.echartsStrValue.xdata,
                                name: ""
                            }
                        ],

                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)"
                            }
                        }
                    }
                ]
            });


        },
        startDialog() {
            if (this.inputsInfo.kehuleixing && this.inputsInfo.hangyechangjing &&
                this.inputsInfo.keqingjieduan && this.inputsInfo.nanyichengdu) {
                this.WxAiChatSession.conversationInputs = this.inputsInfo;
                const myMsg = {
                    type: 2,
                    conter: '开始演练'
                }
                const load = {
                    type: 3,
                    conter: '我正在努力思考，请稍等',
                    stop: false,
                }
                this.diaArr.push(myMsg)
                this.diaArr.push(load)
                this.getTime();
                this.isStartBtn = true;
                this.Dify_requestTask_api('开始演练')
            } else {
                this.$message({
                    message: '请选择演练参数',
                    type: 'danger'
                });
            }
        },
        // 导出word
        outWord(val) {
            this.openLoading()
            exportAiUserChatMsgWord({ yuamrId: val.yuamrId }).then((res) => {
                if (res.status == 200) {
                    this.loadings.close();
                    window.location.href = res.data;
                    this.$message({
                        type: "success",
                        message: "导出成功",
                    });
                }
            });
        },
        // 问答
        queryClick(val) {
            const myMsg = {
                type: 2,
                conter: val
            }
            const load = {
                type: 3,
                conter: '我正在努力思考，请稍等',
                stop: false,
            }
            this.diaArr.push(myMsg)
            this.diaArr.push(load)
            this.getTime();
            this.AnswerIndex = 0;
            this.btnDisabled = true;
            this.Dify_requestTask_api(val)
        },
        // 重新问答
        restConter(index) {
            const qury = this.diaArr[index - 1].conter;
            const yuamrId = this.diaArr[index].yuamrId;
            if (yuamrId) {
                deleteAiUserChat({
                    yuamrId: yuamrId
                }).then(res => {
                    if (res.status == 200) {
                        this.diaArr.splice(index - 1, 2)
                        const myMsg = {
                            type: 2,
                            conter: qury
                        }
                        const load = {
                            type: 3,
                            conter: '我正在努力思考，请稍等',
                            stop: false,
                        }
                        this.diaArr.push(myMsg)
                        this.diaArr.push(load)
                        this.getTime();
                        this.AnswerIndex = 0;
                        this.btnDisabled = true;
                        this.Dify_requestTask_api(qury)
                    }
                })
            } else {
                this.diaArr.splice(index - 1, 2)
                const myMsg = {
                    type: 2,
                    conter: qury
                }
                const load = {
                    type: 3,
                    conter: '我正在努力思考，请稍等',
                    stop: false,
                }
                this.diaArr.push(myMsg)
                this.diaArr.push(load)
                this.getTime();
                this.AnswerIndex = 0;
                this.btnDisabled = true;
                this.Dify_requestTask_api(qury)
            }
        },
        // 开场白的例子
        gotoEg(e) {
            const text = e
            const myMsg = {
                type: 2,
                conter: text
            }
            const load = {
                type: 3,
                conter: '我正在努力思考，请稍等',
                stop: false,
            }
            this.diaArr.push(myMsg)
            this.diaArr.push(load);
            this.getTime();
            this.AnswerIndex = 0;
            this.btnDisabled = true;

            this.Dify_requestTask_api(text)
            this.autoScroll()
        },
        // 优化后的Dify_requestTask_api方法（集成打字机）
        Dify_requestTask_api(val) {
            const vm = this; // Vue实例，替换小程序的that
            // 初始化/重置响应式状态（Vue2用this.$data或this.$set）
            vm.DmxInit()
            vm.isMerge = false;
            vm.mergeArr = [];
            vm.uncompletedLine = '';
            vm.loadingText = '.';
            vm.loadingNums = 0;
            vm.totalAnswerText = ''; // 完整文本池
            vm.displayAnswerText = ''; // 展示文本
            vm.isTyping = false; // 打字状态
            vm.isStreamEnd = false; // 流结束标记
            vm.theItem = null;
            vm.theConversationId = '';

            // 清除残留定时器（Vue2定时器建议挂载到实例上，避免内存泄漏）
            if (vm.typingTimer) {
                clearInterval(vm.typingTimer);
                vm.typingTimer = null;
            }

            // ========== 封装：打字机核心逻辑（逐字渲染） ==========
            const startTyping = () => {
                if (vm.isTyping) return;
                if (vm.totalAnswerText.length === 0) {
                    // 无字符且流已结束，执行收尾
                    if (vm.isStreamEnd) {
                        vm.finishStreamProcessing();
                    }
                    return;
                }

                vm.isTyping = true;
                let currentIndex = vm.displayAnswerText.length;

                // Vue2定时器挂载到实例上，方便销毁
                vm.typingTimer = setInterval(() => {
                    // 1. 逐字渲染
                    if (currentIndex < vm.totalAnswerText.length) {
                        const newDisplayText = vm.totalAnswerText.substring(0, currentIndex + 1);
                        currentIndex++;
                        // Vue2响应式更新（md.render需提前引入MarkdownIt）
                        const contentKey = `diaArr[${vm.diaArr.length - 1}].conter`;
                        const html = md.render(newDisplayText); // 假设Vue2已注册md过滤器/方法

                        // Vue2更新数组对象属性（需用$set保证响应式）
                        vm.$set(vm.diaArr[vm.diaArr.length - 1], 'conter', html);
                        vm.displayAnswerText = newDisplayText;

                        // 自动滚动（Vue2版）
                        vm.autoScroll();
                    }
                    // 2. 所有字符渲染完成
                    else {
                        clearInterval(vm.typingTimer);
                        vm.typingTimer = null;
                        vm.isTyping = false;
                        // 流结束则收尾
                        if (vm.isStreamEnd) {
                            vm.finishStreamProcessing();
                        }
                    }
                }, vm.typingSpeed || 30); // 打字速度，默认30ms/字
            };

            // ========== 封装：追加新字符到字符池 ==========
            const appendAnswerText = (newText) => {
                if (!newText) return;
                // Vue2响应式更新文本池
                vm.totalAnswerText = vm.totalAnswerText + newText;
                // 启动/续接打字机
                startTyping();
            };

            // ========== 封装：解析单行流式数据 ==========
            const processSingleLine = (line) => {
                let jsonObj = null;
                if (!line || !line.startsWith('data: ')) return jsonObj;

                try {
                    const jsonString = line.substring(6).trim();
                    if (jsonString === '[DONE]' || jsonString === '') return null;
                    jsonObj = JSON.parse(jsonString);
                } catch (e) {
                    vm.uncompletedLine = line;
                    console.warn('单行解析失败，缓存未完成行:', line);
                }
                return jsonObj;
            };

            // ========== 封装：解析流式数据分片 ==========
            const parseStreamData = (rawStr) => {
                const jsonObjects = [];
                const uncompletedLine = vm.uncompletedLine;
                const fullStr = uncompletedLine + rawStr;
                const lines = fullStr.split('\n');
                const lastLine = lines.pop() || '';

                lines.forEach(line => {
                    const jsonObj = processSingleLine(line);
                    if (jsonObj) jsonObjects.push(jsonObj);
                });

                if (lastLine) {
                    const tempObj = processSingleLine(lastLine);
                    if (tempObj) {
                        jsonObjects.push(tempObj);
                        vm.uncompletedLine = '';
                    } else {
                        vm.uncompletedLine = lastLine;
                    }
                } else {
                    vm.uncompletedLine = '';
                }

                return jsonObjects;
            };

            // ========== 封装：处理消息项 ==========
            const handleMessageItem = (item) => {
                if (!item) return;

                if (item.conversation_id) {
                    vm.theConversationId = item.conversation_id;
                }

                if (item.event === 'message' && item.event !== 'message_end') {
                    if (vm.DmxIndex === 1) {
                        // Vue2数组操作（splice保证响应式）
                        vm.diaArr.splice(vm.diaArr.length - 1, 1);
                        const AiMsg = {
                            type: 1,
                            conter: '', // 初始为空，打字机填充
                            FollowUpQuery: [],
                            think: '',
                            stop: false,
                            IsCollapse: true,
                        };
                        vm.diaArr.push(AiMsg);

                        // 清除loading定时器（Vue2）
                        if (vm.timeID) clearInterval(vm.timeID);
                        vm.isOpen = true;
                        vm.loadingText = '.';
                        vm.loadingNums = 0;
                    }

                    // 追加新字符到字符池
                    const newAnswerChars = item.answer || '';
                    if (newAnswerChars) {
                        appendAnswerText(newAnswerChars);
                    }

                    // 更新索引
                    vm.AnswerIndex = vm.AnswerIndex + 1;
                    vm.DmxIndex = vm.DmxIndex + 1;
                }

                // 流结束标记
                if (item.event === 'message_end') {
                    if (item.metadata && item.metadata.retriever_resources.length > 0) {
                        vm.diaArr[vm.diaArr.length - 1].fileList = item.metadata.retriever_resources;
                    }
                    vm.theItem = item;
                    vm.isStreamEnd = true;
                    if (!vm.isTyping) {
                        startTyping();
                    }
                }
            };

            // ========== 封装：流结束收尾 ==========
            vm.finishStreamProcessing = function () {

                // 清除定时器
                if (vm.timeID) clearInterval(vm.timeID);
                // 更新结束状态
                vm.$set(vm.diaArr[vm.diaArr.length - 1], 'stop', true);
                vm.isOpen = false;
                vm.btnDisabled = false;
                vm.isStreamEnd = false;
                // Vue2提示（替代wx.showToast）
                vm.$message({
                    message: '回答已完成',
                    type: 'info',
                    duration: 1500
                });

                // 保存会话记录（适配Vue2的接口调用）
                const conversationId = vm.WxAiChatSession.conversationId || vm.theConversationId;
                if (conversationId) {
                    if (vm.WxAiChatSession.conversationId === '') {
                        vm.addChatMsgOne_Dify(conversationId);
                    } else {
                        // Vue2接口调用示例（axios）
                        addAiUserChatMsg({
                            conversationId,
                            aucId: vm.WxAiChatSession.aucId,
                            yuamrQuestion: vm.diaArr[vm.diaArr.length - 2]?.conter || '',
                            yuamrAnswer: vm.diaArr[vm.diaArr.length - 1]?.conter || '',
                            yuamrThink: vm.diaArr[vm.diaArr.length - 1]?.think || '',
                            yuamrFiles: vm.diaArr[vm.diaArr.length - 1].fileList ? JSON.stringify(vm.diaArr[vm.diaArr.length - 1].fileList) : '',
                        }).then(res => {
                            vm.$set(vm.diaArr[vm.diaArr.length - 1], 'yuamrId', res.data?.yuamrId || '');
                            vm.$emit('getChatMsg', '');
                            if (res.data.aucStatus == 2) {
                                var aucAnswerEvaluate = JSON.parse(res.data.aucAnswerEvaluate)
                                if (aucAnswerEvaluate[0].firstArray && aucAnswerEvaluate[0].firstArray.length > 0) {
                                    vm.firstArray = aucAnswerEvaluate[0].firstArray;
                                    vm.secondArray = aucAnswerEvaluate[0].secondArray;
                                    c.echartsStrValue = {
                                        xdata: [],
                                        data: []
                                    };
                                    vm.isOver = true;
                                    vm.$nextTick(() => {
                                        that.initEcharts()
                                    })
                                }
                            }
                        });

                    }
                }
            };

            // ========== 发起流式请求（Vue2用axios替代wx.request） ==========
            // 注意：Vue2实现流式请求需用axios + stream，或fetch API
            const abortController = new AbortController(); // 取消请求控制器（替代小程序的abortRequest）
            vm.abortController = abortController; // 挂载到实例，方便取消

            // Vue2流式请求（使用fetch，axios流式需额外配置）
            fetch(`${vm.agrentData.aaAppBaseUrl}/chat-messages`, {
                method: 'POST',
                signal: abortController.signal,
                timeout: 5 * 60 * 1000,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${vm.WxAiChatSession.aaAppId}`
                },
                body: JSON.stringify({
                    conversation_id: vm.WxAiChatSession.conversationId || null,
                    response_mode: "streaming",
                    query: val,
                    inputs: vm.WxAiChatSession.conversationInputs || {},
                    user: `web-${vm.userInfo}`,
                    files: [],
                })
            }).then(async (response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                // 处理流式响应（Vue2核心）
                const reader = response.body.getReader();
                const decoder = new TextDecoder('utf-8');

                while (true) {
                    // 检测是否停止请求
                    if (vm.isStop) {
                        abortController.abort();
                        reader.cancel();
                        // 停止打字机
                        if (vm.typingTimer) {
                            clearInterval(vm.typingTimer);
                            vm.typingTimer = null;
                            vm.isTyping = false;
                            vm.isStreamEnd = false;
                        }
                        return;
                    }

                    const { done, value } = await reader.read();
                    if (done) break;

                    // 解码分片数据（替代小程序的Base64解码）
                    const decodeStr = decoder.decode(value, { stream: true });
                    if (!decodeStr) continue;

                    let fullDecodeStr = decodeStr;
                    if (vm.isMerge && vm.mergeArr.length > 0) {
                        fullDecodeStr = vm.mergeArr.join('') + decodeStr;
                        vm.mergeArr = [];
                    }

                    // 解析并处理数据
                    const jsonObjects = parseStreamData(fullDecodeStr);
                    if (jsonObjects.length > 0) {
                        jsonObjects.forEach(item => handleMessageItem(item));
                        if (vm.uncompletedLine) {
                            vm.isMerge = true;
                        }
                    } else {
                        vm.mergeArr.push(fullDecodeStr);
                        vm.isMerge = true;
                        vm.loadingText = '';
                        vm.loadingNums = 0;
                    }
                }
            }).catch((err) => {
                console.error('请求失败:', err);
                // 清除定时器
                if (vm.timeID) clearInterval(vm.timeID);
                if (vm.typingTimer) {
                    clearInterval(vm.typingTimer);
                    vm.typingTimer = null;
                    vm.isTyping = false;
                    vm.isStreamEnd = false;
                }

                // Vue2错误提示
                vm.$message.error(`请求出错: ${err.message || err}`);

                // 追加错误消息
                const errorMsg = {
                    type: 1,
                    conter: '请询问的再详细些'
                };
                vm.diaArr.push(errorMsg);

                // 重置状态
                vm.AnswerIndex = 0;
                vm.displayAnswerText = '';
                vm.totalAnswerText = '';
                vm.btnDisabled = false;
                vm.form.question = '';
                vm.loadingNums = 0;
                vm.loadingText = '.';
                vm.uncompletedLine = '';
                vm.mergeArr = [];
            });
        },

        // ========== 辅助方法：自动滚动（Vue2版） ==========
        autoScroll() {
            // 假设滚动容器的ref为chatScrollView
            const scrollEl = this.$refs.chatScrollView;
            if (scrollEl) {
                scrollEl.scrollTop = scrollEl.scrollHeight;
            }
        },

        // ========== 辅助方法：取消请求（Vue2版） ==========
        abortRequest() {
            if (this.abortController) {
                this.abortController.abort();
            }
        },
        // 如果没有对话id,创建第一次对话
        addChatMsgOne_Dify(val) {
            addAiUserChatOneDify({
                aaId: this.WxAiChatSession.aaId,
                conversationId: val,
                conversationInputs: this.WxAiChatSession.conversationInputs ? JSON.stringify(this.WxAiChatSession.conversationInputs) : ''
            }).then(res => {
                this.WxAiChatSession.conversationId = val;
                this.WxAiChatSession.aucId = res.data.aucId;
                addAiUserChatMsg({
                    conversationId: this.WxAiChatSession.conversationId,
                    aucId: this.WxAiChatSession.aucId,
                    yuamrQuestion: this.diaArr[this.diaArr.length - 2].conter,
                    yuamrAnswer: this.diaArr[this.diaArr.length - 1].conter,
                    yuamrThink: this.diaArr[this.diaArr.length - 1].think ? this.diaArr[this.diaArr.length - 1].think : '',
                    yuamrFiles: this.diaArr[this.diaArr.length - 1].fileList ? JSON.stringify(this.diaArr[this.diaArr.length - 1].fileList) : '',
                }).then(res => {
                    this.diaArr[this.diaArr.length - 1].yuamrId = res.data.yuamrId ? res.data.yuamrId : '';
                    this.$emit('getChatMsg', '');
                    if (res.data.aucStatus == 2) {
                        var aucAnswerEvaluate = JSON.parse(res.data.aucAnswerEvaluate)
                        if (aucAnswerEvaluate[0].firstArray && aucAnswerEvaluate[0].firstArray.length > 0) {
                            that.firstArray = aucAnswerEvaluate[0].firstArray;
                            that.secondArray = aucAnswerEvaluate[0].secondArray;
                            that.echartsStrValue = {
                                xdata: [],
                                data: []
                            };
                            that.isOver = true;
                            that.$nextTick(() => {
                                that.initEcharts()
                            })
                        }
                    }
                })
            })
        },
        openDrawer() {
            this.isDrawer = true;
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        DownFile(item) {
            this.openLoading()
            getAiKnowledgeFileUser({
                akwName: item.dataset_name,
                akfName: item.document_name
            }).then(res => {
                const suffix = item.document_name;
                FileSaver.saveAs(res.data.akfPath, suffix)
                this.loadings.close()
                // 下载成功
                this.$message({
                    showClose: true,
                    message: '下载成功',
                    type: 'success'
                });
            })

        },
        // 复制文本
        conterCopy(index) {
            const textToCopy = this.diaArr[index].conter; // 获取要复制的文本
            const plainText = this.convertHtmlToText(textToCopy); // 转换为纯文本
            if (navigator.clipboard) {
                this.copyTextToClipboardUsingClipboardAPI(plainText);
            } else {
                this.copyTextToClipboardLegacy(plainText); // 使用旧的execCommand方法（不推荐）
            }
        },
        copyTextToClipboardUsingClipboardAPI(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$message({
                    showClose: true,
                    message: '复制成功',
                    type: 'success'
                });
            }).catch(err => {
                console.error('复制失败:', err);
            });
        },
        copyTextToClipboardLegacy(text) {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed'; // 防止滚动到顶部
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                this.$message({
                    showClose: true,
                    message: '复制成功',
                    type: 'success'
                });
            } catch (err) {
                console.error('复制失败:', err);
            } finally {
                document.body.removeChild(textArea);
            }
        },
        // 大模型初始化
        DmxInit(val) {
            this.ThinkIndex = 0;
            this.DmxIndex = 0;
            this.AnswerMsg = '';
            this.ThinkMsg = '';
            this.AnswerIndex = 0;

        },
        // 中断请求
        abortStream() {
            if (this.controller) {
                this.controller.abort();
                this.isOpen = false;
                this.btnDisabled = false;

                // this.isStop = false;
                this.controller = null
            }
        },
        // 将html转纯文本
        convertHtmlToText(inputText) {
            var returnText = "" + inputText;
            returnText = returnText.replace(/<\/div>/ig, '\r\n');
            returnText = returnText.replace(/<\/li>/ig, '\r\n');
            returnText = returnText.replace(/<li>/ig, ' * ');
            returnText = returnText.replace(/<\/ul>/ig, '\r\n');
            //-- remove BR tags and replace them with line break
            returnText = returnText.replace(/<br\s*[\/]?>/gi, "\r\n");

            //-- remove P and A tags but preserve what's inside of them
            returnText = returnText.replace(/<p.*?>/gi, "\r\n");
            returnText = returnText.replace(/<a.*href="(.*?)".*>(.*?)<\/a>/gi, " $2 ($1)");

            //-- remove all inside SCRIPT and STYLE tags
            returnText = returnText.replace(/<script.*>[\w\W]{1,}(.*?)[\w\W]{1,}<\/script>/gi, "");
            returnText = returnText.replace(/<style.*>[\w\W]{1,}(.*?)[\w\W]{1,}<\/style>/gi, "");
            //-- remove all else
            returnText = returnText.replace(/<(?:.|\s)*?>/g, "");

            //-- get rid of more than 2 multiple line breaks:
            returnText = returnText.replace(/(?:(?:\r\n|\r|\n)\s*){2,}/gim, "\r\n\r\n");

            //-- get rid of more than 2 spaces:
            returnText = returnText.replace(/ +(?= )/g, '');

            //-- get rid of html-encoded characters:
            returnText = returnText.replace(/&nbsp;/gi, " ");
            returnText = returnText.replace(/&amp;/gi, "&");
            returnText = returnText.replace(/&quot;/gi, '"');
            returnText = returnText.replace(/&lt;/gi, '<');
            returnText = returnText.replace(/&gt;/gi, '>');

            return returnText;
        },
        // 收起or展开 思考
        collapseTap(index) {
            this.diaArr[index].IsCollapse = !this.diaArr[index].IsCollapse
            this.$set(this.diaArr, index, this.diaArr[index])
        },
        // 收起or展开 参考资料
        collapseFileTap(index) {
            this.diaArr[index].IsFlieShow = !this.diaArr[index].IsFlieShow
            this.$set(this.diaArr, index, this.diaArr[index])
        },
        // 
        getTime() {
            var that = this
            that.timeID = setInterval(() => {
                if (that.loadingNums >= 4) {
                    that.loadingNums = 0;
                    that.loadingText = '.'
                }
                that.loadingNums = that.loadingNums + 1,
                    that.loadingText = that.loadingText + '.'

            }, 400) //每隔1s调用一次timer函数
        },
        //获取dify智能体变量

        getAiAppInputsKey() {
            var that = this;
            axios({
                method: 'get',
                url: that.agrentData.aaAppBaseUrl + '/parameters',
                data: '',
                timeout: 1200000,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${that.agrentData.aaAppId}`
                }
            }).then(function (res) {
                console.log(res)
                that.agentVarObj = [];
                that.agentVar = [];
                if (res.data.opening_statement) {
                    that.prologue = {
                        textValue: res.data.opening_statement,
                        type: 4,
                        stop: false,
                        eg: res.data.suggested_questions ? res.data.suggested_questions : [],
                    }

                }
                if (res.data.user_input_form && res.data.user_input_form.length > 0) {
                    console.log('11');
                    res.data.user_input_form.forEach((item, index) => {
                        // 行业场景
                        if (item.select.label == '行业场景') {
                            that.$set(that.inputsInfo, item.select.variable, item.select.default);
                            that.hangyechangjingOptions = item.select.options.map(items => {
                                return {
                                    text: items,
                                    value: items
                                }
                            })
                            that.hangyechangjingOptionsCopy = JSON.parse(JSON.stringify(that.hangyechangjingOptions));
                        }
                        // 客户类型
                        if (item.select.label == '客户类型') {
                            that.$set(that.inputsInfo, item.select.variable, item.select.default);
                            that.kehuleixingOptions = item.select.options.map(items => {
                                return {
                                    text: items,
                                    value: items
                                }
                            })
                        }
                        // 客情阶段
                        if (item.select.label == '客情阶段') {
                            that.$set(that.inputsInfo, item.select.variable, item.select.default);
                            that.keqingjieduanOptions = item.select.options.map(items => {
                                return {
                                    text: items,
                                    value: items
                                }
                            })
                        }
                        // 难易程度
                        if (item.select.label == '难易程度') {
                            that.$set(that.inputsInfo, item.select.variable, item.select.default);
                            that.nanyichengduOptions = item.select.options.map(items => {
                                return {
                                    text: items,
                                    value: items
                                }
                            })
                        }

                    })
                    that.$set(that, 'inputsInfo', that.inputsInfo)
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        getAiAppInputsKey2() {
            var that = this;
            axios({
                method: 'get',
                url: that.agrentData.aaAppBaseUrl + '/parameters',
                data: '',
                timeout: 1200000,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${that.agrentData.aaAppId}`
                }
            }).then(function (res) {
                console.log(res)
                that.agentVarObj = [];
                that.agentVar = [];
                if (res.data.user_input_form && res.data.user_input_form.length > 0) {
                    console.log('11');
                    res.data.user_input_form.forEach((item, index) => {
                        // 行业场景
                        if (item.select.label == '行业场景') {
                            that.hangyechangjingOptions = item.select.options.map(items => {
                                return {
                                    text: items,
                                    value: items
                                }
                            })
                            that.hangyechangjingOptionsCopy = JSON.parse(JSON.stringify(that.hangyechangjingOptions));
                        }
                        // 客户类型
                        if (item.select.label == '客户类型') {
                            that.kehuleixingOptions = item.select.options.map(items => {
                                return {
                                    text: items,
                                    value: items
                                }
                            })
                        }
                        // 客情阶段
                        if (item.select.label == '客情阶段') {
                            that.keqingjieduanOptions = item.select.options.map(items => {
                                return {
                                    text: items,
                                    value: items
                                }
                            })
                        }
                        // 难易程度
                        if (item.select.label == '难易程度') {
                            that.nanyichengduOptions = item.select.options.map(items => {
                                return {
                                    text: items,
                                    value: items
                                }
                            })
                        }

                    })
                    console.log(that.inputsInfo);
                }
                if (res.data.opening_statement) {
                    that.prologue = {
                        textValue: res.data.opening_statement,
                        type: 4,
                        stop: false,
                        eg: res.data.suggested_questions ? res.data.suggested_questions : [],
                    }

                }
            }).catch(function (error) {
                console.log(error);
            });
        },

    }
};
</script>
<style scoped>
.textWrapClass {
    white-space: pre-wrap;
    word-break: break-all;
    word-wrap: break-word;

}

.selectors-section {
    background-color: white;
    border-radius: 20px;
    padding: 15px 20px;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}

.selector-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 16px;
}

.selector-item:last-child {
    margin-bottom: 0;
}

.egclass {
    position: relative;
    max-width: 98%;
    margin: 10px 10px 10px;
    padding: 15px 10px 10px;
    /* background-image: url('https://txcloud.aojuai.com/icon/aojv/aiwx_icon/dhk.png'); */
    /* background-repeat: no-repeat; */
    background-color: #f7f8f9;
    /* background-size: cover; */
    font-size: 16px;
    border-radius: 15px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.message {
    position: relative;
    max-width: 98%;
    margin: 10px;
    padding: 10px;
    background-color: white;
    /* background: linear-gradient(to bottom, #accdf1, white); */
    font-size: 22rpx;
    border-radius: 15px;
    /* display: flex; */
    /* z-index: 10; */
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-container {
    max-width: 400px;
    margin: 50px auto;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    font-family: 'Arial', sans-serif;

}

h2 {
    text-align: center;
    color: #333333;
    font-size: 24px;
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 5px;
    color: #555555;
    font-weight: bold;
}

input {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    border: 1px solid #cccccc;
    border-radius: 5px;
    font-size: 16px;
    transition: border-color 0.3s, box-shadow 0.3s;
}

input:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25);
}

button {
    width: 100%;
    padding: 12px;
    background-color: #42b983;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
}

button:hover {
    background-color: #36956f;
}

.egTitleclass {
    font-size: 21px;
    font-weight: bold;
    position: absolute;
    top: 0px;
    left: 10px;
}

.inputDiv {
    width: calc(100% - 300px - 35%);
    min-height: 130px;
    position: fixed;
    bottom: 20px;
    left: calc(300px + 17%);
    border-radius: 15px;
    border: 1px solid #DCDFE6;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.inputDiv div /deep/ .el-textarea__inner {
    border: none !important;
    resize: none !important;
}

.iconStyle {
    width: 40px;
    height: 40px;
    margin: 10px;
    font-size: 22px;
}

.iconStyle_icon {
    width: 20px;
    height: 20px;
}

.flex-right {
    flex-direction: row-reverse;
}

.flex-right>.message::after {
    left: unset;
    right: -5px;
}

.message2 {
    position: relative;
    max-width: 98%;
    margin: 10px;
    padding: 10px;
    background: white;
    border-radius: 10px 10px 0 10px;
    font-size: 16px;
    color: black;
    /* display: flex; */
    /* z-index: 10; */
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.aoju_title {
    width: calc(100% - 15%);
    font-size: 26px;
    font-weight: 600;
}

@media (max-width: 600px) {
    .aoju_title {
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

    }

    .inputDiv {
        width: 95%;
        min-height: 80px;
        position: fixed;
        bottom: 10px;
        left: 2.5%;
        border-radius: 15px;
        border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

    .egTitleclass {
        font-size: 16px;
        font-weight: bold;
        position: absolute;
        top: 0px;
        left: 10px;
    }

    .mainDiv {
        width: 100% !important;
        height: calc(100% - 100px) !important;

    }

    .login-container {
        padding: 30px;
    }

    h2 {
        font-size: 20px;
    }

    input,
    button {
        font-size: 14px;
        padding: 10px;
    }

    .egclass {
        position: relative;
        max-width: 98% !important;
        margin: 20px 0px 0px;
        padding: 20px 10px 10px;
        /* background-image: url('https://txcloud.aojuai.com/icon/aojv/aiwx_icon/dhk.png'); */
        /* background-repeat: no-repeat; */
        background-color: white;
        /* background-size: cover; */
        font-size: 12px;
        border-radius: 30px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .message2 {
        position: relative;
        max-width: 98%;
        margin: 10px;
        padding: 10px;
        background: white;
        border-radius: 5px 5px 0 5px;
        font-size: 10px !important;
        color: black;
        /* display: flex; */
        /* z-index: 10; */
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    /* 确保没有不必要的外部边距或填充 */
    ol,
    ul,
    dl {
        padding-left: 20px !important;
        /* 移除默认的左填充 */
        margin: 0;
        /* 移除默认的外边距 */
    }

    .message {
        position: relative;
        max-width: 98%;
        margin: 10px;
        padding: 10px;
        /* padding-left: 15px !important; */
        background-color: white;
        /* background: linear-gradient(to bottom, #accdf1, white); */
        border-radius: 15px;
        font-size: 10px !important;
        /* display: flex; */
        /* z-index: 10; */
        overflow: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

}
</style>